<form #contratForm="ngForm" name="contrat-generalites" autocomplete="off">
    <mat-card *ngIf="contenuCharge">
        <mat-card-title>
            <span>{{'admin.frais.fournisseurs.contrat.onglets.generalites' | translate}}</span>
        </mat-card-title>
        <mat-card-content>
            <div class="row">
                <custom-input [(ngModel)]="contrat.libelle"
                              name="libelle"
                              customType="input"
                              libelle="admin.frais.fournisseurs.contrat.libelle"
                              [required]="true"
                              maxlength="30"
                              ngDefaultControl>
                </custom-input>

                <custom-input [(ngModel)]="contrat.dateDebut"
                              [(customModel)]="contrat.dateDebut"
                              name="dateDebut"
                              customType="date"
                              libelle="admin.frais.fournisseurs.contrat.dateDebut"
                              ngDefaultControl>
                </custom-input>
            </div>

            <div class="row">
                <custom-input [(ngModel)]="contrat.numero"
                              name="numero"
                              customType="input"
                              libelle="admin.frais.fournisseurs.contrat.numero"
                              maxlength="20"
                              ngDefaultControl>
                </custom-input>

                <custom-input [(ngModel)]="contrat.dateFin"
                              [(customModel)]="contrat.dateFin"
                              name="dateFin"
                              customType="date"
                              libelle="admin.frais.fournisseurs.contrat.dateFin"
                              ngDefaultControl>
                </custom-input>
            </div>
        </mat-card-content>
    </mat-card>
    <mat-card *ngIf="contenuCharge">
        <mat-card-title>
            <span>{{'admin.frais.fournisseurs.contrat.ImportDonnees' | translate}}</span>
        </mat-card-title>
        <mat-card-content>
            <div class="row">
                <custom-input [(ngModel)]="importSelectionne"
                              name="typeImport"
                              customType="objectselect"
                              libelle="admin.frais.fournisseurs.contrat.typeImport"
                              [required]="true"
                              [selectOptions]="listeImport"
                              optionValue="code"
                              optionDisplay="libelle"
                              (onChange)="onImportChange()"
                              ngDefaultControl>
                </custom-input>

                <custom-input [(ngModel)]="contrat.idTypeEntite"
                              name="idTypeEntite"
                              customType="select"
                              libelle="admin.frais.fournisseurs.contrat.typeEntite"
                              [selectOptions]="listeTypeEntite"
                              optionValue="idTypeEntite"
                              optionDisplay="libelle"
                              ngDefaultControl>
                </custom-input>
            </div>

            <div class="row">
                <custom-input [(ngModel)]="contrat.typeDebit"
                              name="typeDebit"
                              customType="select"
                              libelle="admin.frais.fournisseurs.contrat.typeDebit"
                              [required]="contrat.typeImport === TypeImport.CARTE"
                              [selectOptions]="listeTypesDebit"
                              [disabled]="!(contrat.typeImport === TypeImport.CARTE)"
                              optionValue="type"
                              optionDisplay="libelle"
                              ngDefaultControl>
                </custom-input>

                <custom-input [(ngModel)]="contrat.idStatutValide"
                              name="idStatutValide"
                              customType="select"
                              libelle="admin.frais.fournisseurs.contrat.statutValidation"
                              [selectOptions]="listeStatut"
                              optionValue="idStatut"
                              optionDisplay="libelle"
                              [disabled]="contrat.typeImport === TypeImport.CARTE"
                              ngDefaultControl>
                </custom-input>
            </div>

            <div class="row">
                <custom-input [ngModel]="contrat.creationAuto"
                              [(customModel)]="contrat.creationAuto"
                              name="CreationAuto"
                              customType="checkbox"
                              libelle="admin.frais.fournisseurs.contrat.isCreationAuto"
                              [disabled]="!(contrat.typeImport === TypeImport.CARTE)"
                              ngDefaultControl>
                </custom-input>

                <custom-input [(ngModel)]="contrat.idStatutErreur"
                              name="idStatutErreur"
                              customType="select"
                              libelle="admin.frais.fournisseurs.contrat.statutErreur"
                              [selectOptions]="listeStatut"
                              optionValue="idStatut"
                              optionDisplay="libelle"
                              [disabled]="contrat.typeImport === TypeImport.CARTE"
                              ngDefaultControl>
                </custom-input>
            </div>

            <div class="row">
                <custom-input [(ngModel)]="contrat.commentaire"
                              name="commentaire"
                              customType="textarea"
                              libelle="admin.frais.fournisseurs.contrat.commentaire"
                              areaRows="3"
                              ngDefaultControl>
                </custom-input>
            </div>

        </mat-card-content>
    </mat-card>
</form>
<please-wait class="content" *ngIf="!contenuCharge"></please-wait>
